import { useMemo } from 'react';
import { collectDescendantNodeIds } from 'state/product-description/helper';
import type { ProductNode } from 'state/product-description/model';

import { useCountInvalidFields } from './useCountInvalidFields';

type BlocksNodes = ReadonlyArray<ProductNode | undefined>;
export function useDirectChildrenBlocksInvalidFields(blocksNodes: BlocksNodes) {
  const blocksFieldIds = useMemo(() => blocksNodes.map(node => collectDescendantNodeIds(node)), [blocksNodes]);
  return useCountInvalidFields(blocksFieldIds);
}
